
      var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check_e53f10878c2aaeb0__clip0_9553_15109)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  rx: 1.5,
  stroke: "var(--theme-primary, #9631ff)",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.293 6.34a.986.986 0 0 1 1.414 0L7 8.68l4.293-4.381a.986.986 0 0 1 1.414 0c.39.398.39 1.044 0 1.443l-5 5.102a.986.986 0 0 1-1.414 0l-3-3.061a1.035 1.035 0 0 1 0-1.443Z",
  fill: "var(--theme-primary, #9631ff)"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  rx: 1.5,
  stroke: "var(--theme-primary, #9631ff)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n  <g clip-path=\"url(#clip0_9553_15109)\">\r\n    <rect width=\"16\" height=\"16\" rx=\"2\" fill=\"white\" />\r\n    <rect x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"1.5\" stroke=\"var(--theme-primary, #9631ff)\" stroke-linejoin=\"round\" />\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.29289 6.3397C3.68335 5.94127 4.31655 5.94127 4.70708 6.3397L7 8.67944L11.2929 4.29888C11.6834 3.90037 12.3166 3.90037 12.7071 4.29888C13.0976 4.69738 13.0976 5.34344 12.7071 5.74195L7.70713 10.844C7.31667 11.2424 6.68347 11.2425 6.29294 10.844L3.29296 7.78277C2.90236 7.38433 2.90236 6.73821 3.29289 6.3397Z\" fill=\"var(--theme-primary, #9631ff)\" />\r\n  </g>\r\n  <rect x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"1.5\" stroke=\"var(--theme-primary, #9631ff)\" />\r\n  <defs>\r\n    <clipPath id=\"clip0_9553_15109)\">\r\n      <rect width=\"16\" height=\"16\" rx=\"2\" fill=\"white\" />\r\n    </clipPath>\r\n  </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/check.e53f10878c2aaeb0e580f801f478b73f.svg"),
        {
          React: SvgCheck,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      